export const createDeleteApiKeyForm = id => "marketplaceDeleteApiKeyForm" + id;
export const createEditApiKeyForm = id => "marketplaceEditApiKeyForm" + id;